export default __webpack_public_path__ + "static/rh-small-1024-b93f5982a1331ab84d394c34e6e99afa.png";